export default "__VITE_ASSET__0e63f308__"